import { APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { IPutMoveLineItems } from "api/rpc/2022-09/facilityAdmin/cart/cart";
import { CancelToken } from "axios";
import { ICart, IUpdatedDynamicComboSelection } from "redux/reducers/models/cart";

export type TPostLineItemToCart = {
  cart_id: number;
  variants: Array<{
    variant_id: string | number;
    quantity: number;
    parent_id?: number;
    kitchen_meal_id?: number;
    prepaid_required?: boolean;
    dynamic_combo_selections?: IUpdatedDynamicComboSelection[];
  }>;
  line_items_stack?: boolean;
};

export type TPutLineItemToCart = {
  id: string | number;
  quantity?: number;
  price?: number;
  note?: string;
  fulfillment_status?: "fulfilled" | "unfulfilled" | "hold" | "void";
  kitchen_meal_id?: string | number;
  dynamic_combo_selections?: IUpdatedDynamicComboSelection[];
  tax_exemption_applied?: boolean;
};

export async function PostLineItemToCart(params: TPostLineItemToCart, useGlobalLoader: boolean) {
  return await APIPost<ICart>(APIUrl(AdminType.FacilityAdmin, "/cart/line-item"), params, useGlobalLoader);
}

export async function PutLineItemToCart(params: TPutLineItemToCart, useGlobalLoader: boolean) {
  return await APIPut<ICart>(APIUrl(AdminType.FacilityAdmin, "/cart/line-item"), params, useGlobalLoader);
}

export async function DeleteLineItemToCart(params: { id: number }, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/cart/line-item"), params, useGlobalLoader);
}

/** Standalone endpoint to only allow certain users to access it */
export async function PutPrice(params: { id: string | number; price: number }, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/cart/line-item/price"), params, useGlobalLoader);
}

export async function PutMoveLineItems(params: IPutMoveLineItems, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/cart/line-item/move"), params, useGlobalLoader);
}

export async function PutCartVariants(params: TPostLineItemToCart, useGlobalLoader: boolean, cancelToken: CancelToken) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/cart/variants"), params, useGlobalLoader, cancelToken);
}
